import { serviceV2 } from '@/utils/request'

const prefix = '/company/interview-meeting-room'

export default {
  getInterviewMeetingRoomList (params) {
    return serviceV2.get(`${prefix}/`, { params })
  },
  getInterviewMeetingRoomById (id, params) {
    return serviceV2.get(`${prefix}/${id}/`, { params })
  },
  createInterviewMeetingRoom (params) {
    return serviceV2.post(`${prefix}/`, params)
  },
  updateInterviewMeetingRoom (id, data) {
    return serviceV2.put(`${prefix}/${id}/`, data)
  },
  deleteInterviewMeetingRoom (id) {
    return serviceV2.delete(`${prefix}/${id}/`)
  },
  getInterviewMeetingRoomSchedule (data) {
    return serviceV2.post(`${prefix}/schedules/`, data)
  }
}
